/**
 * List of Shipping Notice states
 *
 * @namespace tmrShippingNoticeStates
 * @type {ngConstant}
 */
export const constant = [
  'tmrShippingNoticeStates',
  {
    DRAFT: 'SHIPPINGNOTICESTATES.DRAFT',
    READY_TO_SEND: 'SHIPPINGNOTICESTATES.READYTOSEND',
    SEND_AWAIT: 'SHIPPINGNOTICESTATES.SENDAWAIT',
    OUTBOUND_ERROR: 'SHIPPINGNOTICESTATES.OUTBOUNDERROR',
    IN_INBOUND: 'SHIPPINGNOTICESTATES.INBOUND',
    RECEIVE_AWAIT: 'SHIPPINGNOTICESTATES.RECEIVEAWAIT',
    READY_TO_RECEIVE: 'SHIPPINGNOTICESTATES.READYTORECEIVE',
    INBOUND_ERROR: 'SHIPPINGNOTICESTATES.INBOUNDERROR',
    RECEIVED: 'SHIPPINGNOTICESTATES.RECEIVED',
    IN_TRANSIT: 'SHIPPINGNOTICESTATES.TRANSIT',
    COMPLETED: 'SHIPPINGNOTICESTATES.COMPLETED',
  },
]

/**
 * Translates {@link tmrShippingNoticeStates}
 *
 * @type {ngRun}
 */
let tmrShippingNoticeStatesRun = /*@ngInject*/ (
  TmrTranslate,
  tmrShippingNoticeStates
) => TmrTranslate.object(tmrShippingNoticeStates)

export { tmrShippingNoticeStatesRun as run }
